<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import { IAppointmentForWeeklyCalenderDTO } from "@shared/types";
import { formatOnlyHour } from "@/Utilities/dateUtility";
import { appointmentsModule } from "@/store/modules/appointments/appointmentModule";
import { userModule } from "@/store/modules/user/userModule";

@Component({
  name: "AppointmentListItem",
})
export default class AppointmentListItem extends Vue {
  @Prop({ required: true }) readonly appointment!: IAppointmentForWeeklyCalenderDTO;
  @Prop({ required: true }) readonly hasMultipleStaff!: boolean;
  @Prop({ required: true }) readonly isMobile!: boolean;

  formatDateStringHour(date: Date) {
    return formatOnlyHour(date);
  }

  isDone(item: IAppointmentForWeeklyCalenderDTO) {
    return item.status === "Ferdig";
  }

  getAgendaColor(status: IAppointmentForWeeklyCalenderDTO) {
    return status.color;
  }

  getBlockedText(item: IAppointmentForWeeklyCalenderDTO) {
    if (this.hasMultipleStaff && item.name.length > 0) {
      return item.name + " - " + item.staffMemberName;
    }
    return item.name;
  }

  gotoAppointment(num: number) {
    appointmentsModule.appointmentSource = "admin";
    this.$router.push("/bestillinger/" + num).catch(() => {});
  }

  get giftCardFeatureEnabled(): boolean {
    return !!userModule.user?.useGiftCards;
  }

  readNote(note: string) {
    this.$emit("read-note", note);
  }

  readComment(comment: string) {
    this.$emit("read-comment", comment);
  }
}
</script>

<template>
  <v-list-item
    :dark="appointment.isCustom"
    class="ma-1"
    :class="{ 'agenda-disabled': appointment.isCustom }"
    :style="'background-color: ' + getAgendaColor(appointment) + '; border-radius: 4px'"
  >
    <template #default="{ active, toggle }">
      <v-list-item-content>
        <v-row
          v-if="appointment.isCustom"
          style="pointer-events: none"
        >
          <v-col cols="1">
            <v-icon
              class="mt-1"
              color="black"
            >
              block
            </v-icon>
          </v-col>
          <v-col>
            <v-list-item-subtitle
              class="text--black"
              style="font-weight: bold"
            >
              {{
                getBlockedText(appointment)
              }}
            </v-list-item-subtitle>
            <v-list-item-subtitle
              class="text--black"
              style="color: hsla(0, 0%, 100%, 0.7)"
            >
              {{
                formatDateStringHour(appointment.start) + " - " + formatDateStringHour(appointment.end)
              }}
            </v-list-item-subtitle>
          </v-col>
        </v-row>
        <v-row
          v-else
          @click="gotoAppointment(appointment.appointmentNumber)"
        >
          <v-col
            v-if="!isMobile"
            cols="1"
          >
            <v-checkbox
              v-model="appointment.status"
              :true-value="'Ferdig'"
              :false-value="'Ny'"
              @click.stop="$emit('toggle-finished', appointment)"
            />
          </v-col>
          <v-col cols="10">
            <v-list-item-subtitle
              v-if="appointment.customerId === 0 || appointment.customerId === -1 || appointment.customerId == null"
              class="text--white"
              style="font-weight: bold"
            >
              {{ appointment.name }}
            </v-list-item-subtitle>
            <v-list-item-subtitle
              v-else
              class="text--white"
            >
              <router-link
                v-if="appointment.appointmentNumber !== 0"
                style="font-weight: bold"
                class="text--white"
                :to="'/kunder/' + appointment.customerId"
              >
                {{ appointment.name }}
              </router-link>
            </v-list-item-subtitle>

            <v-list-item-subtitle
              v-if="!appointment.isCustom"
              class="text--white"
            >
              {{ appointment.appointmentName }}
            </v-list-item-subtitle>
            <v-list-item-subtitle
              v-if="!appointment.isCustom && hasMultipleStaff && appointment.staffMemberName.trim().length > 0"
              class="text--white"
            >
              {{ appointment.staffMemberName }}
            </v-list-item-subtitle>
            <v-list-item-subtitle
              v-if="giftCardFeatureEnabled && appointment.hasGiftCardRedemption"
              class="text--white d-flex align-center"
            >
              <v-icon
                small
                class="mr-1"
                color="white"
              >
                mdi-card-text-outline
              </v-icon>
              {{ $t($ts.appointmentSummary.hasGiftCardRedemption) }}
            </v-list-item-subtitle>

            <v-list-item-subtitle style="color: hsla(0, 0%, 100%, 0.7)">
              {{ formatDateStringHour(appointment.start) + " - " + formatDateStringHour(appointment.end) }}
            </v-list-item-subtitle>

            <v-list-item-subtitle
              v-if="appointment.adminNote != null && appointment.adminNote.length > 0"
              class="text--white"
            >
              <span
                style="color: #3f51b5; text-decoration: underline"
                @click.stop="readNote(appointment.adminNote)"
              >{{
                $t("readNotes")
              }}</span>
            </v-list-item-subtitle>

            <v-list-item-subtitle
              v-if="appointment.comment != null && appointment.comment.length > 0"
            >
              <span
                class="text--white"
                style="color: #3f51b5; text-decoration: underline"
                @click.stop="readComment(appointment.comment)"
              >{{ $t("readCustomerComment") }}</span>
            </v-list-item-subtitle>
          </v-col>

          <!-- <v-col>
            <v-scroll-x-transition>
              <v-icon v-if="isDone(appointment)" color="white"> mdi-check </v-icon>
            </v-scroll-x-transition>
          </v-col> -->
        </v-row>
      </v-list-item-content>
    </template>
  </v-list-item>
</template>
